export const getFriendsSelector = state => state.friends.friendsData;
